
import FulfillmentOptionsStockInfo from './FulfillmentOptionsStockInfo.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from 'src/js/types/LocalStore';
import { IProductDetailProductJson } from '../../../types/PDP';

@Component({
	name: 'FulfillmentOptionsFooterPickup',
	components: {
		FulfillmentOptionsStockInfo
	}
})
export default class FulfillmentOptions extends Vue {
	/* Computed
	============================================*/

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	@Get('isInStockForBopus')
	readonly isInStockForBopus: boolean;

	@Get('isInStockInStore')
	readonly isInStockInStore: boolean;

	get showStockInfo() {
		return this.stockSubscriptionFormEnabled || !this.outOfMarket;
	}

	get outOfMarket(): boolean {
		return !this.localStore;
	}

	get stockSubscriptionFormEnabled(): boolean {
		return 	!this.isInStockForBopus &&
				!this.isInStockInStore &&
		 		!this.product.notCarriedInStore &&
				!this.outOfMarket &&
				this.product.backInStockInfo.isProductEligible &&
				this.hasSelectedVariant &&
				!this.fetchingProduct;
	}
}
